import { render } from "./CStep1.vue?vue&type=template&id=5d8b3540&ts=true"
import script from "./CStep1.vue?vue&type=script&lang=ts"
export * from "./CStep1.vue?vue&type=script&lang=ts"

import "./CStep1.vue?vue&type=style&index=0&id=5d8b3540&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__